import { createActions, createReducer } from 'reduxsauce'

import DetalhesTransfFinAdmService from '../../servicos/DetalhesTransfFinAdmService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesTransfFinAdmInicio: [],
    buscaDetalhesTransfFinAdmSucesso: ['detalhesTransfFinAdm'],
    buscaDetalhesTransfFinAdmErro: ['erro'],
    setSelecionadoPorOrgaoSucesso: ['selecionado'],
    setDetalhesTransfFinAdmEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDetalhesTransfFinAdm = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesTransfFinAdmInicio())
        let serv = new DetalhesTransfFinAdmService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesTransfFinAdmSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesTransfFinAdmErro(error)))
    }
}

const buscaDetalhesTransfFinAdmInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesTransfFinAdmErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesTransfFinAdmSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesTransfFinAdm.resultado, dataAtualizacaoDados: action.detalhesTransfFinAdm.dataAtualizacaoDados, carregando: false }
}

const setSelecionadoPorOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setDetalhesTransfFinAdmEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_TRANSF_FIN_ADM_INICIO]: buscaDetalhesTransfFinAdmInicio,
    [Types.BUSCA_DETALHES_TRANSF_FIN_ADM_ERRO]: buscaDetalhesTransfFinAdmErro,
    [Types.BUSCA_DETALHES_TRANSF_FIN_ADM_SUCESSO]: buscaDetalhesTransfFinAdmSucesso,
    [Types.SET_SELECIONADO_POR_ORGAO_SUCESSO]: setSelecionadoPorOrgaoSucesso,
    [Types.SET_DETALHES_TRANSF_FIN_ADM_ESTADO_DT]: setDetalhesTransfFinAdmEstadoDT,
})
